"use client"

import { Checkbox, Label } from "@medusajs/ui"
import React from "react"

type CheckboxProps = {
  checked?: boolean
  onChange?: () => void
  label: string
  name?: string
  'data-testid'?: string
}

const CheckboxWithLabel: React.FC<CheckboxProps> = ({
  checked = false,
  onChange,
  label,
  name,
  'data-testid': dataTestId
}) => {
  // `useId` da un id único por instancia. Antes todas las casillas usaban
  // id="checkbox" y todas las etiquetas htmlFor="checkbox": el navegador
  // asociaba cada etiqueta con la PRIMERA casilla del DOM, así que al pulsar
  // "Aboca" o "Garganta y tos" se marcaba la primera opción de la lista y el
  // filtro aplicado no era el que el usuario había seleccionado.
  const id = React.useId()

  return (
    <div className="flex items-center space-x-2 ">
      <Checkbox
        className="text-base-regular flex items-center gap-x-2"
        id={id}
        checked={checked}
        onCheckedChange={() => onChange?.()}
        name={name}
        data-testid={dataTestId}
      />
      <Label
        htmlFor={id}
        className="!transform-none !txt-medium cursor-pointer"
        size="large"
      >
        {label}
      </Label>
    </div>
  )
}

export default CheckboxWithLabel
